import { supportedWarehousesForRatioAndDua } from '@gonfalon/dogfood-flags/dogfood-flags';
import { ExperimentDataSourceKind } from '@gonfalon/experiments/types';

const WAREHOUSE_NATIVE_DATA_SOURCES: string[] = Object.values(ExperimentDataSourceKind).filter(
  (kind) => kind !== ExperimentDataSourceKind.LAUNCHDARKLY,
);
const WAREHOUSE_EXPERIMENTATION_KEY_SUFFIX = '-experimentation';

const toWarehouseKey = (dataSource: string) =>
  dataSource.endsWith(WAREHOUSE_EXPERIMENTATION_KEY_SUFFIX)
    ? dataSource.slice(0, -WAREHOUSE_EXPERIMENTATION_KEY_SUFFIX.length)
    : dataSource;

// Accepts a warehouse key or an experimentation integration key. Hosted, empty and unknown sources are never enabled.
export const ratioAndDuaEnabledFor = (dataSource?: string | null) => {
  if (typeof dataSource !== 'string' || dataSource.length === 0) {
    return false;
  }

  const warehouse = toWarehouseKey(dataSource);
  if (!WAREHOUSE_NATIVE_DATA_SOURCES.includes(warehouse)) {
    return false;
  }

  // A misconfigured flag can resolve to any JSON value at runtime, which must fail closed.
  const supportedWarehouses: unknown = supportedWarehousesForRatioAndDua();
  if (!Array.isArray(supportedWarehouses)) {
    return false;
  }

  return supportedWarehouses.some((entry) => typeof entry === 'string' && entry === warehouse);
};
